import type { ComponentStyle } from "@yamada-ui/core"
import { mergeStyle } from "@yamada-ui/core"
import { Airy } from "./airy"

export const Rotate: ComponentStyle<"Rotate"> = mergeStyle(Airy)()
